const BillPayments = () => import("Modules/supply_chain/bills/views/BillPayments");
const BillPaymentsForm = () => import("Modules/supply_chain/bills/views/BillPaymentsForm");

export default {
    children: [
        {
            path: "purchasing/payments",
            name: "bill_payments",
            component: BillPayments,
            meta: {
                requiresAuth: true,
                title: "lang.bill_payments",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["bills.read"],
            },
        },
        {
            path: "purchasing/payment/:id?",
            name: "bill_payment",
            component: BillPaymentsForm,
            meta: {
                requiresAuth: true,
                title: "lang.bill_payments",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["bills.read"],
            },
        },
    ],
};
